import React, { useState } from 'react';
// map
import { Marker, Layer, Source } from 'react-map-gl';
import { RulerStartMarker } from './RulerStartMarker';
import { RulerEndMarker } from './RulerEndMarker';
import lineStringFeature from './LineStringFeature';
import { Position, Projection, Vector3 } from 'common-logic';
import { getConvertedDistance, isWithinSnapBoundaries } from '../../../../utils';
import { useEffect } from 'react';
import { RULER_SNAP_OFFSET } from '../../../../constants';
export const RulerTool = ({ isRulerEnabled, coordinates, mapProjection, units, handleDragEvent, addressCoordinates, mapApis, }) => {
    if (!isRulerEnabled) {
        return null;
    }
    // Ruler Tool State
    const [addressScreenPosition, updateAddressScreenPosition] = useState(undefined);
    const [distanceMeasurement, updateDistance] = useState('');
    const [linestring, updateLineString] = useState(lineStringFeature([
        [coordinates.start.longitude, coordinates.start.latitude],
        [coordinates.end.longitude, coordinates.end.latitude],
    ]));
    // Updates and the line between start and end points and calls the new distance function
    const updateRuler = (markerName, pointerLngLat) => {
        const lngLat = checkAndSnapToAddress(pointerLngLat);
        if (markerName === 'start') {
            updateLineString(lineStringFeature([lngLat, [coordinates.end.longitude, coordinates.end.latitude]]));
        }
        else {
            updateLineString(lineStringFeature([[coordinates.start.longitude, coordinates.start.latitude], lngLat]));
        }
        getDistance(markerName, lngLat);
        handleDragEvent(markerName, lngLat);
    };
    const turfToProjected = (projectionString, coordinateStart, coordinateEnd) => {
        Projection.current = new Projection(projectionString);
        const worldStartPoint = new Position(coordinateStart[1], coordinateStart[0], 0);
        const worldEndPoint = new Position(coordinateEnd[1], coordinateEnd[0], 0);
        const localStartPoint = Projection.current.toLocalCoordinates(worldStartPoint);
        const localEndPoint = Projection.current.toLocalCoordinates(worldEndPoint);
        return Vector3.distance(localStartPoint, localEndPoint);
    };
    const getDistance = (markerName, lngLat) => {
        if (markerName && lngLat) {
            const start = markerName === 'start' ? lngLat : [coordinates.start.longitude, coordinates.start.latitude];
            const end = markerName === 'end' ? lngLat : [coordinates.end.longitude, coordinates.end.latitude];
            updateDistance(getConvertedDistance(turfToProjected(mapProjection, start, end), units, 2));
        }
        else {
            updateDistance(getConvertedDistance(turfToProjected(mapProjection, [coordinates.start.longitude, coordinates.start.latitude], [coordinates.end.longitude, coordinates.end.latitude]), units, 2));
        }
    };
    // Checks if current coordinates should snap to address
    const checkAndSnapToAddress = (lngLat) => {
        if (addressScreenPosition &&
            addressCoordinates &&
            isWithinSnapBoundaries(lngLat, addressScreenPosition, RULER_SNAP_OFFSET, mapApis)) {
            return [addressCoordinates.longitude, addressCoordinates.latitude];
        }
        else {
            return lngLat;
        }
    };
    // Sets the distance of the ruler when ruler is turned on
    useEffect(() => {
        if (isRulerEnabled) {
            getDistance();
        }
    }, [isRulerEnabled]);
    // sets/updates address screen position when address geo changed or map zoomed in or out
    useEffect(() => {
        if (addressCoordinates &&
            addressCoordinates.longitude !== 0 &&
            addressCoordinates.latitude !== 0) {
            updateAddressScreenPosition(mapApis.project([addressCoordinates.longitude, addressCoordinates.latitude]));
        }
        else {
            updateAddressScreenPosition(undefined);
        }
    }, [addressCoordinates, mapApis.transform._zoom]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Source, { id: "line-string-data", type: "geojson", data: linestring },
            React.createElement(Layer, { id: `RULER_LAYER_LINE`, type: 'line', source: 'line-string-data', paint: {
                    'line-color': '#0b6bf2',
                    'line-width': 2,
                    'line-dasharray': [2, 1],
                } })),
        React.createElement(Marker, { longitude: coordinates.start.longitude, latitude: coordinates.start.latitude, draggable: true, onDrag: ({ lngLat }) => {
                updateRuler('start', lngLat);
            }, onDragEnd: ({ lngLat }) => {
                updateRuler('start', lngLat);
            } },
            React.createElement(RulerStartMarker, null)),
        React.createElement(Marker, { longitude: coordinates.end.longitude, latitude: coordinates.end.latitude, draggable: true, onDrag: ({ lngLat }) => {
                updateRuler('end', lngLat);
            }, onDragEnd: ({ lngLat }) => {
                updateRuler('end', lngLat);
            } },
            React.createElement(RulerEndMarker, { distanceMeasurement: distanceMeasurement }))));
};
//# sourceMappingURL=RulerTool.js.map